<template>
  <div v-if="bankAccount" class="bank_account_wrap">
    <p>
      Quý cha mẹ học sinh vui lòng chuyển khoản phí trên đúng và đủ qua số tài khoản đã được chỉ định của giáo viên chủ
      nhiệm.
    </p>
    <div class="bank_account_name">
      <p>Ngân hàng:</p>
      <span>{{ bankAccount && bankAccount.bankName.toUpperCase() }}</span>
    </div>
    <div class="bank_account_number">
      <p>Số tài khoản:</p>
      <span>{{ bankAccount && bankAccount.accountNumber }}</span>
    </div>
    <div class="bank_account_username">
      <p>Tên tài khoản:</p>
      <span>{{ bankAccount && bankAccount.accountHolder }}</span>
    </div>
    <div class="bank_account_note">
      <p>Nội dung chuyển khoản:</p>
      <span>{{ getTransferContent() }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      bankAccount: null
    }
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
      report: 'tuitionFeeReport/report'
    })
  },
  async created() {
    if (this.report.class) this.bankAccount = await this.fetchBankAccount({ class: this.report.class.id })
  },
  methods: {
    ...mapActions({
      fetchBankAccount: 'bankAccount/fetchBankAccount'
    }),
    getTransferContent() {
      let convertFullDate = this.$options.filters.convertFullDate(this.detailPeriod.title)
      if (this.report.class && this.detailPeriod) {
        return `${this.report.class.title} - ${this.report.student.name} - Nộp phí ${convertFullDate}`
      }
    }
  }
}
</script>
<style lang="scss">
.bank_account_wrap {
  padding: 20px 20px 0 20px;
  margin: 20px 0 0 0;
}
.bank_account_wrap > .bank_account_name,
.bank_account_number,
.bank_account_username,
.bank_account_note {
  display: flex;
  margin: 12px 0;
}
.bank_account_wrap > .bank_account_name p,
.bank_account_number p,
.bank_account_username p,
.bank_account_note p {
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 1px 8px 0 0;
}
</style>
